<template>
  <div
    class="login-background"
    v-show="isShow"
    @mousedown="mouseDownBackground"
  >
    <div
      id="firebaseui-auth-container"
      class="centered"
      @mousedown.stop="mouseDownLoginArea"
    ></div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { firebaseAuth } from '@/libs/firebase'

export default {
  name: 'Login',
  data() {
    return {
      isShow: false
    }
  },
  computed: {
    ...mapState(['loginData'])
  },
  methods: {
    login() {
      firebaseAuth.login({
        loginSuccess: this.loginSuccess,
        loginFail: this.loginFail,
        loginNewUser: this.loginNewUser
      })
    },
    loginSuccess(authResult) {
      this.$emit('loginSuccessHandler', authResult)
      this.isShow = false
    },
    loginFail(error, emailVerify = false, user = undefined) {
      this.$emit('loginFailHandler', error, emailVerify, user)
    },
    loginNewUser(uid, email) {
      log('Login.vue loginNewUser()')
      this.$emit('loginNewUserHandler', uid, email)
    },
    mouseDownBackground() {
      this.isShow = false
    },
    mouseDownLoginArea() {
      return
    }
  },
  watch: {
    loginData() {
      if (this.loginData.isShow) {
        this.isShow = true
        this.login()
      } else {
        this.isShow = false
      }
    }
  }
}
</script>

<style scoped>
.login-background {
  position: absolute;
  width: 100%;
  height: 100%;
  background: #0008;
  z-index: 100;
}
</style>
